import ApiCore from '../utilities/Core';

export const apiActivation = new ApiCore({
    get: false,
    getSingle: false,
    search: false,
    post: true,
    put: false,
    delete: false,
    url: 'activation',
    plural: 'activation',
    single: 'activation',
});
